import {defineAsyncComponent} from 'vue'

export default {
  install: (app, options) => {
    app.component('GiftCardBuilder', defineAsyncComponent(() => import('./Builder.vue')))
  }
}
